import {
 
  MailOutlined,
  PhoneOutlined ,
  ProjectOutlined,
  NumberOutlined,

  EnvironmentOutlined
} from "@ant-design/icons";
import TextIcon from "../../assets/images/Texticon";
import DateIcon from "../../assets/images/DateIcon";
import RadioButtonIcon from "../../assets/images/RadiobuttonIcon";
import MultiSelectIcon from "../../assets/images/MultiselectIcon";
import SelectIcon from "../../assets/images/SelectIcon";
import NumberIcon from "../../assets/images/NumberIcon";
import DecimalIcon from "../../assets/images/DecimalIcon";
const ImageProvider = [
  {
    id: 1,
    icon: "",
    image: "",
    svg: TextIcon,
    dataType: 0,
  },
  {
    id: 2,
    icon: "",
    image: "",
    svg: NumberIcon,
    dataType: 2,
  },
  {
    id: 3,
    icon: "",
    image: "",
    svg: RadioButtonIcon,
    dataType: 3,
  },
  {
    id: 4,
    icon: "",
    image: "",
    svg: MultiSelectIcon,
    dataType: 6,
    typeOfOptions: "Multiple",
  },
  {
    id: 4,
    icon: "",
    image: "",
    svg: SelectIcon,
    dataType: 6,
    typeOfOptions: "Single",
  },
  {
    id: 5,
    icon: "",
    image: "",
    svg: DateIcon,
    dataType: 7,
  },
  {
    id: 6,
    icon: "",
    image: "",
    svg: MailOutlined,
    dataType: 8,
  },
  {
    id: 7,
    icon: "",
    image: "",
    rotate:110,

    svg: PhoneOutlined,
    dataType: 9,
  },
  {
    id: 8,
    icon: "",
    image: "",
    svg: DecimalIcon,
    dataType: 12,
  },
  {
    id: 9,
    icon: "",
    image: "",

    svg: DateIcon,
    dataType: 13,
  },
  {
    id: 10,
    icon: "",
    image: "",
    svg: EnvironmentOutlined,
    dataType: 14,
  },
  {
    id: 11,
    icon: "",
    image: "",
    rotate:270,
    svg:ProjectOutlined,
    dataType: 1,
  },
];
export default ImageProvider;
